module.exports = __webpack_public_path__ + "assets/img/组 538@2x.cd904033.png";